import { Input } from '@ember/component';
import { on } from '@ember/modifier';

import didInsert from 'webapp/modifiers/did-insert';
import type { Args as BaseArgs } from 'webapp/components/form/text-base';
import FormTextBaseComponent from 'webapp/components/form/text-base';

interface Args extends BaseArgs {
	type?: string;
}

export default class FormInputComponent extends FormTextBaseComponent<Args> {
	<template>
		<Input
			class="{{this.themeClass}} {{this.sizeClass}}"
			autocomplete="off"
			...attributes
			@type={{@type}}
			{{! @glint-expect-error: @value is two-way bound to the caller's property, which can be a number; Glint types Input @value as string }}
			@value={{@value}}
			@insert-newline={{this.insertNewline}}
			{{didInsert this.setupView}}
			{{on "input" this.input}}
			{{on "focusin" this.focusIn}}
			{{on "focusout" this.focusOut}}
			{{on "keydown" this.keyDown}}
		/>
	</template>
}
